"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { twMerge } from "tailwind-merge"
import { EventCarouselContent } from "./components/EventCarouselContent"
import type { EventCarouselProps } from "./types"

export const RenderConfig: ComponentConfig<EventCarouselProps> = {
  render: ({
    title,
    className,
    viewAllUrl,
  }: EventCarouselProps & { viewAllUrl?: string }) => {
    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    const locale = (params?.locale as string) || storeLocale || "vi"
    return (
      <>
        <EventCarouselContent title={title} className={twMerge(className)} viewAllUrl={viewAllUrl} locale={locale} />
      </>
    )
  },
}
